import gql from 'graphql-tag';

export const VideoFragments = {
  id: gql`
    fragment VideoId on Video {
      id
    }
  `,
};
